class MenuNavigation extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger']
  }

  setupListeners () {
    super.setupListeners()

    this.handleTriggerClick = this.handleTriggerClick.bind(this)
    this.handleDrawerChange = this.handleDrawerChange.bind(this)

    this.els.trigger.elements.forEach((trigger) => {
      trigger.addEventListener('click', this.handleTriggerClick)
    })

    document.addEventListener(
      'drawer-changed',
      this.handleDrawerChange,
    )
  }

  get submenus () {
    return document.querySelectorAll(
      '[data-menu-navigation-submenu]',
    )
  }

  handleTriggerClick (event) {
    const handle = event.currentTarget.dataset.handle

    this.submenus.forEach((submenu) => {
      submenu.hidden =
        submenu.dataset.menuNavigationSubmenu !== handle
    })

    this.els.trigger.elements.forEach((trigger) => {
      trigger.setAttribute(
        'aria-expanded',
        String(trigger === event.currentTarget),
      )
    })
  }

  handleDrawerChange () {
    if (window.drawers.activeDrawerKey === 'mobile-menu-child') return

    this.els.trigger.elements.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false')
    })
  }
}

if (!customElements.get('menu-navigation')) {
  customElements.define('menu-navigation', MenuNavigation)
}